//import axios from 'axios';
//import authHeader from './auth-header';
import api from "./api"; //Added 2024-04-18 for refreshToken


class UserPlaylistDataService {
  get(data) {
    //return axios.get(process.env.VUE_APP_ROOT_API + `userplaylist`, { headers: authHeader(), params: data}); //Replaced 2024-04-18 due to RefreshToken
    return api.get(`userplaylist`, { params: data});
  }

  update(id, data) {
    //return axios.put(process.env.VUE_APP_ROOT_API + `userplaylist/${id}`, data, { headers: authHeader()}); //Replaced 2024-04-18 due to RefreshToken
    return api.put(`userplaylist/${id}`, data);
  }
}

export default new UserPlaylistDataService();